
import { get as apiGet } from 'Api';

const language = window.locale || 'en';

/**
 *  Retrieve user tags for a product
 * @type {String} productId
 * @return {Array} user tags
 */
export const getSuggestedTagsByProductId = async (productId) => {
  const { response, data } = await apiGet([], `/products/tags/get-suggested-by-product-id/${productId}/${language}`);
  if (response.ok) return data;

  throw new Error(data.message || response.status);
};


export async function getFanFavourites({ hitsPerPage, onSale, newReleases }) {
  let recommendations = [];
  let url = `/products/get-fan-favourites?hitsPerPage=${hitsPerPage}&language=${language}`;

  if (onSale) {
    url = `/products/get-fan-favourites?hitsPerPage=${hitsPerPage}&onSale=true&excludeGiveaway=true&language=${language}`;
  }

  if (newReleases) {
    url = `/products/get-fan-favourites?hitsPerPage=${hitsPerPage}&language=${language}&newReleases=true`;
  }

  try {
    const { response, data } = await apiGet([], url);
    if (response.ok) recommendations = data;
  } catch (ex) { /* */ }

  return recommendations;
}

